import EmptyState from "src/shared/components/layout/empty-state/EmptyState"
import "./ReportError.css"

const ReportError = ({ onRetry }: { onRetry: () => void }) => {
    return (
        <EmptyState
            containerClassName="report-error"
            headerIcon="Exclamation"
            title="No se pudieron cargar los reportes"
            subtitle="Ocurrió un error al cargar los reportes, intenta nuevamente en unos momentos"
            button="Reintentar"
            onClick={onRetry}
        />
    )
}

export default ReportError
